<template>
  <div class="login">
    <div class="logo">
      <img src='../assets/images/logo1@2x.png' alt=""/>
    </div>
    <div class="input">
      <div class="input-vp">
        <i class="icon"></i>
        <input type="text" list="email-list" class="email input-view" placeholder="Enter your Email or Phone Number" v-model="email" @keydown.enter.prevent="login"/>
        <!-- <datalist id="email-list"> -->
          <!-- <option v-for="email in emailList">{{email}}</option> -->
        <!-- </datalist> -->
      </div>
      <div class="input-vp">
        <i class="icon"></i>
        <input type="password" class="password input-view" placeholder="Enter your password" v-model="password" @keydown.enter.prevent="login" autocomplete="new-password"/>
        <img src="../assets/images/rememberpw_off@2x.png" class="rememberpw" title="Remember your password" v-show="!rememberpw" @click="rememberpw = !rememberpw">
        <img src="../assets/images/rememberpw_on@2x.png" class="rememberpw" title="Don't remember your password" v-show="rememberpw" @click="rememberpw = !rememberpw">
      </div>
    </div>
    <div class="btn" @click="login">Login</div>
    <div class="choose">
      <router-link to="/forgot" class="link">Forgot Password</router-link>
      <!-- <router-link to="/signup" class="link">Sign Up</router-link> -->
    </div>
    <router-link to="/qrcode">
      <div class="change" >
        <img src='../assets/images/icon_qrcode@2x.png' alt=""/>
      </div>
    </router-link>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import CryptoJS from 'crypto-js'
import { Message } from 'element-ui'
export default {
  data () {
    return {
      email: '',
      emailList: [],
      password: '',
      rememberpw: false,
      passwordArr: [],
      passwordObj: {}
    }
  },
  mounted () {
    this.passwordArr = JSON.parse(localStorage.getItem('passwords'))
    if (!this.passwordArr || this.passwordArr.length === 0) {
      localStorage.setItem('passwords', JSON.stringify([]))
      this.passwordArr = []
    } else {
      this.getEmailAndPassword()
      this.getEmailList()
      this.transferArrToObj()
      if (this.password !== '') {
        this.rememberpw = true
      }
    }
  },
  watch: {
    email () {
      if (this.passwordObj[this.email]) {
        let publickey = this.getPublickey()
        let md5 = this.getMd5(publickey)
        this.password = this.aesDecrypt(md5, this.passwordObj[this.email])
      }
    }
  },
  methods: {
    // aes加密
    aesEncrypt (key, string) {
      let iv = CryptoJS.enc.Latin1.parse(key)
      let encrypted = CryptoJS.AES.encrypt(string, iv, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.toString()
    },
    // aes解密
    aesDecrypt (key, string) {
      let iv = CryptoJS.enc.Latin1.parse(key)
      let decrypted = CryptoJS.AES.decrypt(string, iv, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      return decrypted.toString(CryptoJS.enc.Utf8)
    },
    // 获取publickey
    getPublickey () {
      return localStorage.getItem(this.email + '_publickey')
    },
    // 获取md5
    getMd5 (publickey) {
      return CryptoJS.MD5(publickey).toString().substr(8, 16)
    },
    // 存储登录信息
    saveEmailAndPassword () {
      this.deleteEmailAndPassword() // 保存信息先去重
      let publickey = this.getPublickey()
      let md5 = this.getMd5(publickey)
      let passwordObj = {}
      if (this.rememberpw) {
        passwordObj[this.email] = this.aesEncrypt(md5, this.password)
      } else {
        passwordObj[this.email] = ''
      }
      this.passwordArr = []
      this.passwordArr.push(passwordObj)
    },
    // 删除登录信息
    deleteEmailAndPassword () {
      for (let i in this.passwordArr) {
        if (this.email === Object.keys(this.passwordArr[i])[0]) {
          this.passwordArr.splice(i, 1)
          break
        }
      }
    },
    // 获取登录信息
    getEmailAndPassword () {
      let password = this.passwordArr[this.passwordArr.length - 1]
      this.email = Object.keys(password)[0]
      let publickey = this.getPublickey()
      let md5 = this.getMd5(publickey)
      this.password = this.aesDecrypt(md5, Object.values(password)[0])
    },
    // 获取登录邮箱列表
    getEmailList () {
      this.passwordArr.forEach((item) => {
        this.emailList.push(Object.keys(item)[0])
      })
    },
    // 将密码数组转换为对象
    transferArrToObj () {
      for (let i in this.passwordArr) {
        this.passwordObj[Object.keys(this.passwordArr[i])[0]] = Object.values(this.passwordArr[i])[0]
      }
    },
    login () {
      this.$emit('show')
      let publickey = this.getPublickey()
//      let reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
//      let reg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((\\-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\\.|\\-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/
      let reg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\.|-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/
      let data = {}
      if (reg.test(this.email)) {
        data = {
          email: this.email,
          password: this.password,
          // useragent: 'web',
          // 此cryptojs版本有bug，需要tostring转换一下
          key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
        }
      } else {
        data = {
          phone_md5: CryptoJS.MD5(this.email).toString().substr(8, 16),
          password: this.password,
          // useragent: 'web',
          // 此cryptojs版本有bug，需要tostring转换一下
          key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
        }
      }
      if (!localStorage.getItem('pcVersion')) {
        data['useragent'] = 'web'
      } else {
        data['useragent'] = localStorage.getItem('pcVersion')
      }
      axios.post('/proxy-api/client/user/index/web-login', qs.stringify(data)
      ).then((result) => {
        if (result.data.status === '0') {
          this.$emit('hide')
          Message({
            message: 'Success!',
            type: 'success'
          })
          // if (this.rememberpw) {
          //   this.saveEmailAndPassword()
          // } else {
          //   this.deleteEmailAndPassword()
          // }
          this.saveEmailAndPassword()
          localStorage.setItem('passwords', JSON.stringify(this.passwordArr))
          // localStorage.setItem('email', this.email)
          location.href = '../web/index.html'
        } else {
          this.$emit('hide')
          Message({
            message: result.data.msg,
            type: 'error'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.$emit('hide')
        Message({
          message: 'Warning!',
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Login.vue?1adba0af